import {Component} from '@angular/core';

@Component({
    selector: 'app-download-page',
    templateUrl: './download-page.component.html',
    styleUrls: ['./download-page.component.scss'],
    standalone: false
})
export class DownloadPageComponent {
}
